import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Ramassage from '@/features/rammasage'

export const Route = createFileRoute('/_authenticated/rammasage/')({
  component: Ramassage,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Ramassage`,
      },
    ],
  }),
  validateSearch: (search: Record<string, unknown>) => {
    return search
  },
})
